import ItemSelect from '../modules/ui/product_item/Select'

export default {
  components: { ItemSelect },
  data() {
    return {}
  },
  computed: {
    dd: {
      get: function() {
        return this.value
      },
      set: function(n) {
        this.$emit('input', n)
      }
    }
  },
  props: {
    list: Array,
    multiple: Boolean,
    disabled: Boolean,
    hints: String
  },
  methods: {
    isOptionExists(v, options) {
      for (let o of options) {
        if (o.value == v) {
          return true
        }
      }

      return false
    },
    ageOptions() {
      let ages = [0, 17, 30, 35, 40, 45, 50, 55, 60, 65, 70, 80, 90, 999]
      let options = []
      for (let age of ages) {
        options.push({
          value: age,
          display: age > 200 ? '终生' : age + '岁'
        })
        if (age > 0 && age < 200) {
          options.push({
            value: age + 1,
            display: (age + 1) + '岁'
          })
        }
      }
      return options
    },
    largeAmountOptions() {
      let options = []
      let amounts = []

      for (let i = 0; i < 1001; i += 10) {
        let x = -1
        if (i <= 200) {
          x = i
        } else {
          if (i % 50 == 0) {
            x = i
          }
        }

        if (x > 0) {
          amounts.push(x)
        }
      }

      for (let x of amounts) {
        options.push({
          value: x,
          display: x + '万元'
        })
      }

      return options
    },
    periodOptions(years = []) {
      if (years.length == 0) {
        years = [1, 5, 10, 15, 20, 25, 30]
        // for (let i = 1; i < 31; i++) {
        //   if (i % 5 > 0) {
        //     years.push(i)
        //   }
        // }
      }

      let options = []
      for (let y of years) {
        options.push({
          value: y,
          display: y + '年'
        })
      }

      return options
    },
    yearOptions(years = []) {
      if (years.length == 0) {
        for (let i = 0; i < 51; i++) {
          years.push(i)
        }
      }

      return this.periodOptions(years)
    }
  }
}
